import { createSlice } from "@reduxjs/toolkit";

const resetPassSlice = createSlice({
  name: "resetPassword",
  initialState: {
    resetData: null,
    isFetching: false,
    error: false,
  },
  reducers: {
    resetPassRequest: (state) => {
      state.isFetching = true;
    },
    resetPassSuccess: (state, action) => {
      state.isFetching = false;
      state.resetData = action.payload;
    },
    resetPassFailure: (state, action) => {
      state.isFetching = false;
      state.error = true;
    },
  },
});

export const { resetPassRequest, resetPassSuccess, resetPassFailure } =
  resetPassSlice.actions;
export default resetPassSlice.reducer;
